import { render, staticRenderFns } from "./FormBrand.vue?vue&type=template&id=b1324126&scoped=true&"
import script from "./FormBrand.vue?vue&type=script&lang=js&"
export * from "./FormBrand.vue?vue&type=script&lang=js&"
import style0 from "./FormBrand.vue?vue&type=style&index=0&id=b1324126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1324126",
  null
  
)

export default component.exports